<div class="cd_public-information-update">
	<div class="info">
		<p>
			{{ header }}
		</p>
	</div>
	<edit-item-group
		[propertyGroup]="propertyGroup"
		[parentForm]="parentForm"
		[mode]="Mode.Company"
	>
	</edit-item-group>
</div>
